import { fetchWithAuth } from "../../utils/httpInterceptor";

const coreBaseUrl =
  process.env.REACT_APP_CORE_BACKEND_URL || process.env.REACT_APP_LOAD_PAGE_URL;

const getFileNameFromDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1].replace(/"/g, ""));
  }
  const basicMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  return basicMatch ? basicMatch[1] : null;
};

class GridReportService {
  static async export(payload) {
    const response = await fetchWithAuth("/api/core/reports/export", {
      baseUrl: coreBaseUrl,
      method: "POST",
      body: JSON.stringify(payload),
    });
    const blob = await response.blob();
    const extension = payload.format === "XLSX"
      ? "xlsx"
      : payload.format.toLowerCase();
    const responseFileName = getFileNameFromDisposition(
      response.headers.get("content-disposition"),
    );
    const fileName = responseFileName || `${payload.fileName}.${extension}`;
    const downloadUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = downloadUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(downloadUrl);
  }
}

export default GridReportService;
